import { appComponent } from './app.component';

// Preload all available locales
import 'angular-i18n/angular-locale_de';
import 'angular-i18n/angular-locale_en';

export const AvailableLocales = ['de', 'en'];

export const appState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    abstract: true,
    name: 'app',
    redirectTo: 'home',
    component: appComponent.name,
    resolve: {
      languageOptions: (
        $translate,
        $locale,
        $location,
        controllerService,
        store,
        $cookies,
        appService,
      ) => {
        // Get default lang
        const defaultLang = $translate.use();

        // Get optional language parameter from url
        const paramLang = $location.search().lang;

        // Check for current lang from storage
        const currentLang = store.get('lang');

        // Set request lang using paramLang > currentLang > defaultLang
        let lang = paramLang || currentLang || defaultLang;

        // Ensure to only load an available locale
        if (AvailableLocales.indexOf(lang) === -1) {
          lang = defaultLang;
        }

        // Set and store application language
        appService.setLang(lang);

        // Get and store the initial requested url to redirect to after login.
        // NOTE that this is only done if the initial url is not the login page.
        const initialUrl = $location.url();
        if (!`${initialUrl}`.startsWith('/login')) {
          $cookies.put('initialUrl', initialUrl);
        }

        return controllerService.tmhDynamicLocale.set(lang).then(() => {
          const { longDate, mediumDate, shortDate } = $locale.DATETIME_FORMATS;
          return {
            lang,
            dateFormat: longDate,
            longDate,
            mediumDate,
            shortDate,
          };
        });
      },
    },
  });
};
